export class GetResourceResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resource",
            "baseName": "resource",
            "type": "InventoryResource",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetResourceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
